import { StyledIcon } from 'src/styles/theme/components/NGIcon/NGIcon.styles';
import { EMediaQuery } from 'src/styles/theme/utils/enums';
import { mq } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

export const StyledImageContainer = styled.div`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 50%;
	margin-top: 20px;

	& > ${StyledIcon} {
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		height: 60px;
		z-index: 10;

		${(p) =>
			`background-image: radial-gradient(170% 170% at 50% 50%, ${p.theme.colors.white} 0%, rgba(255, 177, 0, 0) 100%);`}
	}

	@media (max-height: 900px) {
		height: 50%;
	}

	@media (max-height: 800px) {
		display: none;
	}

	${mq(EMediaQuery.md, 'display: none;')}
`;

export const StyledTextContainer = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	margin-top: -60px;
	padding: 24px 24px;
	padding-bottom: 12px;
	background: linear-gradient(179.47deg, rgba(255, 207, 121, 0.1) 0.46%, rgba(190, 167, 126, 0.078) 99.54%);
	backdrop-filter: blur(2.5px);

	@media (max-height: 800px) {
		margin-top: 40px;
	}

	& > p {
		min-height: 70px;
		${mq(EMediaQuery.xl, `min-height: 90px;`)}
	}

	${mq(
		EMediaQuery.md,
		`
				margin-top: 0px;
				padding: 20px;
				width: 90%;
				border-radius: 5px;
				backdrop-filter: unset;

				& > p {
					min-height: unset;
					max-width: 90%;
				}
			`
	)}

	&::before {
		content: ' ';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}
`;

export const StyledOverviewCard = styled.li`
	position: relative;
	width: 100%;
	height: 100%;

	${mq(
		EMediaQuery.md,
		css`
			height: auto;
		`
	)}
`;
